import ScheduleEntity, { ScheduleDay } from "../../domain/entities/ScheduleEntity";

/**
 * Returns the numeric order of a day of the week (1-7)
 * Lunes (Monday) = 1, Domingo (Sunday) = 7
 */
export const getDayOrder = (day: ScheduleDay): number => {
    const order = {
        [ScheduleDay.lunes]: 1,
        [ScheduleDay.martes]: 2,
        [ScheduleDay.miercoles]: 3,
        [ScheduleDay.jueves]: 4,
        [ScheduleDay.viernes]: 5,
        [ScheduleDay.sabado]: 6,
        [ScheduleDay.domingo]: 7,
    };
    return order[day] ?? 999;
};

/**
 * Converts a time string in format "HH:MM" to total minutes
 * Example: "08:30" -> 510 (8*60 + 30)
 */
export const timeToMinutes = (time: string): number => {
    const [hours, minutes] = time.split(':').map(Number);
    return (hours * 60) + minutes;
};

/**
 * Comparator function for sorting ScheduleEntity arrays
 * Sorts by:
 * 1. Day of week (Lunes -> Domingo)
 * 2. Opening time (ascending)
 */
export const compareSchedules = (a: ScheduleEntity, b: ScheduleEntity): number => {
    // First, compare by day of week
    const dayDiff = getDayOrder(a.day) - getDayOrder(b.day);
    if (dayDiff !== 0) return dayDiff;

    // If same day, compare by opening time
    return timeToMinutes(a.openTime) - timeToMinutes(b.openTime);
};
